import { useState, useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import { 
    AppLabel, AppSpan, AppText, Button, Circle, CustomContainer, Divider, 
    FixedContainer, FlexColumn, FlexRow, GridContainer, Icon 
} from "src/style"
import ProfilePics from 'src/assets/img/profile-pics-lg.svg'
import { ReactComponent as VerifiedCustomersIcon } from 'src/assets/img/verified-customers.svg'
import { ReactComponent as OrangeFruitHead } from 'src/assets/img/head-orange.svg'
import { IoLocationOutline } from "react-icons/io5"
import { BsPhone, BsTelephone } from "react-icons/bs"
import { AiOutlineMail } from "react-icons/ai"
import { CustomerInfoView } from "src/component"
import { Call, MoreFeature, SendMessage } from "src/popup"
import { useNavigate } from "react-router-dom"

export const CustomerInfo: React.FC = () => {
    const navigate = useNavigate()
    const {info: {searchedUserInfo}} = useContext(AppInfoContext)
    const [morePosition, setMorePosition] = useState({x: 75, y: 49.5})
    const [showMore, setShowMore] = useState(false)
    const [showSendMessage, setShowSendMessage] = useState(false)
    const [showCall, setShowCall] = useState(false)

    function handleMore (e: any) {
        setMorePosition({x: e.clientX/10, y: e.clientY/10})
        setShowMore(true)
    }

    return (
        <>
            <CustomContainer >
                <FixedContainer left="23" top="5.7" zIndex="2" width="100"  sizeUnit="%" bgColor="#ffffff">
                    <AppText className='customer-nav'>
                        <AppSpan 
                            textSize="1.1" fontWeight="500" color="#A0AEC0" 
                            hoverColor="#425466" cursor="pointer"
                            onClick={() => navigate(-1)}
                        > 
                            Customer &gt; 
                        </AppSpan>
                        <AppSpan textSize="1.1" fontWeight="500" cursor="pointer"> Customer details &gt; </AppSpan>
                        <AppSpan textSize="1.1" fontWeight="500"> {searchedUserInfo?.firstName} {searchedUserInfo?.lastName} </AppSpan>
                    </AppText> 
                </FixedContainer>
                <CustomContainer leftPadding="27.8">
                    <FixedContainer 
                        height="full" top="10.2" left="23"
                        leftPadding="2.5" rightPadding="1.8" width="27.8"
                        className="customer-details-container"
                    >
                        <CustomContainer overflow="auto" height="80" hUnit="%" bottomPadding="2">
                            <FlexRow justifyContent="space-between" alignItems="flex-start">
                                <Circle size='6.4' rightMargin="1.5" overflow="hidden">
                                    <Icon noResize minWidth='100' style={{objectFit: 'cover'}} src={searchedUserInfo?.document?.picture || ProfilePics} />
                                </Circle>
                                <CustomContainer width="auto" sizeUnit="">
                                    <VerifiedCustomersIcon/>
                                    <AppSpan textSize="1" fontWeight="600" leftPadding="1">{searchedUserInfo?.isAddressVerified ? 'VERIFIED' : 'UNVERIFIED'}</AppSpan>
                                </CustomContainer>
                            </FlexRow>
                            <FlexRow topMargin="1.5">
                                <GridContainer width="7.2" height="2.4" radius="2.1" bgColor="#DEFFEE" rightMargin="0.5">
                                    <AppSpan textSize="1.2" fontWeight="600" color="#4AAE8C">{searchedUserInfo?.isAccountVerified ? 'Active' : 'Inactive'}</AppSpan>
                                </GridContainer>
                                <GridContainer width="8.2" height="2.4" radius="2.1" bgColor="#E1E8FF">
                                    <FlexRow width="auto" sizeUnit="">
                                        <OrangeFruitHead/>
                                        <AppSpan textSize="1.2" fontWeight="600" color="#4C6FFF" leftPadding="0.3">INTJ</AppSpan>
                                    </FlexRow>
                                </GridContainer>
                            </FlexRow>
                            <CustomContainer topMargin="1">
                                <AppText textSize="1.8" fontWeight="600">{searchedUserInfo?.firstName} {searchedUserInfo?.lastName}</AppText>
                                <FlexRow justifyContent="space-between">
                                    <AppText textSize="1.2" color="#A0AEC0">Customer ID - {searchedUserInfo.customerId}</AppText>
                                    <AppSpan textSize="1.2" color="#A0AEC0">-</AppSpan>
                                    <AppText textSize="1.2" color="#A0AEC0">Joined {searchedUserInfo?.dateJoined}</AppText>
                                </FlexRow>
                            </CustomContainer>
                            <Divider margin="2" bgColor="rgba(237, 242, 247, 0.5)" />
                            <CustomContainer>
                                <AppLabel textSize="1.2" color="#A0AEC0">
                                    <IoLocationOutline style={{color: '#4C6FFF', fontSize: '1.6rem'}} /> Address
                                </AppLabel>
                                <AppText topMargin="0.7">{searchedUserInfo?.address}</AppText>
                            </CustomContainer>
                            <CustomContainer topMargin="2.5">
                                <AppLabel textSize="1.2" color="#A0AEC0">
                                    <BsPhone style={{color: '#4C6FFF', fontSize: '1.6rem'}} /> Phone Number
                                </AppLabel>
                                <AppText topMargin="0.7">{searchedUserInfo?.phoneNumber}</AppText>
                            </CustomContainer>
                            <CustomContainer topMargin="2.5">
                                <AppLabel textSize="1.2" color="#A0AEC0">
                                    <AiOutlineMail style={{color: '#4C6FFF', fontSize: '1.6rem'}} /> Email Address
                                </AppLabel>
                                <AppText topMargin="0.7">{searchedUserInfo?.email}</AppText>
                            </CustomContainer>
                            <CustomContainer topMargin='4'>
                                <CustomContainer>
                                    <FlexRow justifyContent='space-between'>
                                        <AppSpan>Credit Score</AppSpan>
                                        <AppSpan fontWeight="600">{searchedUserInfo?.totalCreditScore}</AppSpan>
                                    </FlexRow>
                                    <FlexColumn height='2' radius='0.2'>
                                        <FlexRow height='0.4' justifyContent='flex-start' alignItems='flex-start'>
                                            <CustomContainer width='30.4' sizeUnit='%' height='0.4' bgColor='#FF5050'/>
                                            <CustomContainer width='20.5' sizeUnit='%' height='0.4' bgColor='#FF7650' />
                                            <CustomContainer width='20.76' sizeUnit='%' height='0.4' bgColor='#FFB750' />
                                            <CustomContainer width='14.3' sizeUnit='%' height='0.4' bgColor='#4DDBA4' />
                                            <CustomContainer width='14' sizeUnit='%' height='0.4' bgColor='#50A379' />
                                        </FlexRow>
                                        <CustomContainer 
                                            className='score-pointer'
                                            style={{left: `${searchedUserInfo?.totalCreditScore || 0}%`}}
                                            width='0.4' bgColor='#425466'
                                        />
                                    </FlexColumn>
                                </CustomContainer>
                                <CustomContainer topMargin='1.5'>
                                    <FlexRow justifyContent='space-between'>
                                        <AppSpan>Reputation Score</AppSpan>
                                        <AppSpan fontWeight="600">0</AppSpan>
                                    </FlexRow>
                                    <FlexColumn height='2' radius='0.2'>
                                        <FlexRow height='0.4' justifyContent='flex-start' alignItems='flex-start'>
                                            <CustomContainer width='30.4' sizeUnit='%' height='0.4' bgColor='#FF5050'/>
                                            <CustomContainer width='20.5' sizeUnit='%' height='0.4' bgColor='#FF7650' />
                                            <CustomContainer width='20.76' sizeUnit='%' height='0.4' bgColor='#FFB750' />
                                            <CustomContainer width='14.3' sizeUnit='%' height='0.4' bgColor='#4DDBA4' />
                                            <CustomContainer width='14' sizeUnit='%' height='0.4' bgColor='#50A379' />
                                        </FlexRow>
                                        <CustomContainer 
                                            className='score-pointer'
                                            style={{left: `${searchedUserInfo?.totalReputationalScore || 0}%`}}
                                            width='0.4' bgColor='#425466'
                                        />
                                    </FlexColumn>
                                </CustomContainer>
                            </CustomContainer>
                            <CustomContainer topMargin="5">
                                <Button
                                    width='100' sizeUnit='%' borderColor='#4C6FFF' height='4.8'
                                    hoverBgColor='#ffffff' hoverColor='#4C6FFF'
                                    onClick={() => setShowSendMessage(true)}
                                >
                                    <AiOutlineMail style={{marginRight: '1rem'}} /> 
                                    Send message to {searchedUserInfo?.firstName}
                                </Button>
                                <FlexRow justifyContent="space-between" topMargin="1.5">
                                    
                                    <Button
                                        width='14.8' borderColor='none' height='4.8'
                                        hoverBgColor='#4AAE8C' hoverColor='#ffffff'
                                        bgColor="#E4ECF7" color="#505780" rightMargin="1"
                                        onClick={() => setShowCall(true)}
                                    >
                                        <BsTelephone style={{marginRight: '1rem'}} /> 
                                        Call {searchedUserInfo?.firstName}
                                    </Button>
                                    <Button
                                        width='8.3' borderColor='none' height='4.6'
                                        hoverBgColor='#4AAE8C' hoverColor='#ffffff'
                                        bgColor="#E4ECF7" color="#505780"
                                        onClick={handleMore}
                                    >
                                        More
                                    </Button>
                                </FlexRow>
                            </CustomContainer>
                        </CustomContainer>
                    </FixedContainer>

                    <CustomerInfoView data={searchedUserInfo} />
                </CustomContainer>
            </CustomContainer>
            { showMore &&
                <MoreFeature
                    top={String(morePosition.y - 10.5)}
                    left={String(morePosition.x + 4)}
                    close={() => setShowMore(false)} 
                />
            }
            { showSendMessage &&
                <SendMessage
                    close={() => setShowSendMessage(false)} 
                />
            }
            { showCall &&
                <Call
                    close={() => setShowCall(false)} 
                />
            }
        </>
    )
}